/**
 * True for the logout page and its single-fetch data request, matched as React
 * Router matches routes: any case, an optional trailing slash, and
 * percent-encoded letters.
 */
export function isLogoutPath(pathname: string): boolean {
  let path = pathname;
  try {
    path = decodeURIComponent(pathname);
  } catch {
    // Malformed escapes: match the raw path.
  }
  path = path.toLowerCase().replace(/\/+$/, "");
  return path === "/logout" || path === "/logout.data";
}

/**
 * The page a sign-out from `href` should come back to: the document URL (a
 * single-fetch `.data` suffix stripped, the fragment kept), and for a /logout URL the page *it*
 * returns to, so logout redirects never nest inside each other (FOX-6551).
 */
export function logoutReturnUrl(href: string): string {
  let url = new URL(href);
  while (isLogoutPath(url.pathname)) {
    const next = url.searchParams.get("redirectUrl");
    try {
      url = next ? new URL(next, url.origin) : new URL("/", url.origin);
    } catch {
      url = new URL("/", url.origin);
    }
  }
  const pathname = url.pathname.endsWith(".data")
    ? // eslint-disable-next-line lingui/no-unlocalized-strings -- URL suffix
      url.pathname.slice(0, -".data".length)
    : url.pathname;
  return `${url.origin}${pathname}${url.search}${url.hash}`;
}

/** The /logout URL that signs out and comes back to `href`. */
export function logoutRedirectFor(href: string): string {
  return `/logout?redirectUrl=${encodeURIComponent(logoutReturnUrl(href))}`;
}
